import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-contract-attachment-dropzone',
	styleUrls: ['./contract-attachment-dropzone.component.scss'],
	templateUrl: './contract-attachment-dropzone.component.html',
})
export class ContractAttachmentDropzoneComponent {
	@Input() acceptedExtensions: string = '';
	@Output() fileSelected = new EventEmitter<File>();
	@Input() isDisabled: boolean = false;
	@Input() isProcessing: boolean = false;
	@Output() selectionError = new EventEmitter<string>();

	isDraggingOver: boolean = false;

	onDragLeave(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();
		const target = event.relatedTarget as Node | null;

		if (!target || !(event.currentTarget as Node).contains(target)) {
			this.isDraggingOver = false;
		}
	}

	onDragOver(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();

		if (!this.isDisabled) {
			this.isDraggingOver = true;
		}
	}

	onDrop(event: DragEvent): void {
		event.preventDefault();
		event.stopPropagation();
		this.isDraggingOver = false;

		if (!this.isDisabled && event.dataTransfer?.files) {
			this.selectSingleFile(event.dataTransfer.files);
		}
	}

	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;

		if (!this.isDisabled && input.files) {
			this.selectSingleFile(input.files);
		}

		input.value = '';
	}

	private selectSingleFile(files: FileList): void {
		if (files.length === 1) {
			const file = files.item(0);

			if (file) {
				this.fileSelected.emit(file);
			}
		} else {
			this.selectionError.emit('Envie apenas um arquivo por vez.');
		}
	}
}
